import { NavLink } from "react-router-dom";

const Admin = ({ leaveCount }) => {
  return (
    <ul className="sidebar-menu">
      <li>
        <NavLink className="nav-link" to="/home">
          <i className="fas fa-home"></i> <span>Dashboard</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/employees">
          <i className="fas fa-users"></i> <span>Employees</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/leaders">
          <i className="fas fa-users"></i> <span>Leaders</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/admins">
          <i className="fas fa-user"></i> <span>Admins</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/teams">
          <i className="fas fa-fire"></i> <span>Teams</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/attendance">
          <i className="fas fa-user"></i> <span>Attendance</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/leaves">
          <i className="fas fa-book"></i>
          <span
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Leaves</span>
            <span
              class="badge badge-light"
              style={{
                width: "40px",
                backgroundColor: "#6777EF",
                color: "white",
              }}
            >
              {leaveCount}
            </span>
          </span>
        </NavLink>
      </li>
      {/* <li><NavLink className="nav-link" to="/assignSalary"><i class="fas fa-pen"></i> <span>Assign Salary</span></NavLink></li> */}
      {/* <li><NavLink className="nav-link" to="/salaries"><i class="fas fa-piggy-bank"></i> <span>Salaries</span></NavLink></li> */}

      <li className="menu-header">Starter</li>
      <li>
        <NavLink className="nav-link" to="/adduser">
          <i className="fas fa-user-plus"></i> <span>Add User</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/addteam">
          <i className="fas fa-address-card"></i> <span>Add Team</span>
        </NavLink>
      </li>
      <li>
        <NavLink className="nav-link" to="/addJobDescription">
          <i className="far fa-square"></i> <span>Add Job Description</span>
        </NavLink>
      </li>

      {/* <li className="menu-header">Settings</li> */}
      {/* <li><NavLink className="nav-link" to="/contact"><i className="fab fa-teamspeak"></i> <span>Contact Us</span></NavLink></li>
        <li><NavLink className="nav-link" to="/about"><i className="fas fa-info-circle"></i> <span>About Us</span></NavLink></li> */}
      <li className="text-center p-7 mt-5">
        <span className="text-muted relative bottom-0">Version 1.1.0</span>
      </li>
    </ul>
  );
};

export default Admin;
